import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { timeByClockFormat } from "utils/dateHelpers"

const TimeAnswer = ({ className = "answer", rawAnswer = undefined, isNewQuestion = false }) => {
  const clockFormat = useSelector(getClockFormat)

  if (isNewQuestion) return null

  return (
    <div className={className}>
      {rawAnswer ? timeByClockFormat(rawAnswer, clockFormat) : null}
    </div>
  )
}

TimeAnswer.propTypes = {
  className: types.string,
  rawAnswer: types.string,
  isNewQuestion: types.bool,
}

export default TimeAnswer
